import { render, staticRenderFns } from "./mdc-card.vue?vue&type=template&id=11f7ac11&scoped=true&"
import script from "./mdc-card.vue?vue&type=script&lang=ts&"
export * from "./mdc-card.vue?vue&type=script&lang=ts&"
import style0 from "./mdc-card.vue?vue&type=style&index=0&id=11f7ac11&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f7ac11",
  null
  
)

export default component.exports